<style lang="less" scoped>
  .btn-right-mes {
    margin-left: 10px;
    line-height: 32px;
  }
  
  .withdrawal-mes {
    margin: 0px 0px 16px 30px;
  }
  
  /deep/ .hide .el-upload--picture-card {
    display: none;
  }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">充电桩报表</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营类别</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.isHostOperate" clearable
                         @change="handleSelectOperate">
                <el-option label="自运营" value="02"></el-option>
                <el-option label="代运营" value="01"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营商名称</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.dealNo" clearable filterable
                         @change="getSite">
                <el-option v-for="item in dealerArr" :key="item.id" :label="item.dealName" :value="item.dealNo"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站名称</div>
            <div class="query-inputs-div flex-1">
              <el-select class="full-width" size="small" v-model="queryInfo.stationNo" clearable filterable
                         no-data-text="暂无数据">
                <el-option v-for="item in siteArr" :key="item.stationNo" :label="item.stationName" :value="item.stationNo"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">选择自然月</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker value-format="yyyy-MM" v-model="queryInfo.chargeMonth" style="width: 100%;"
                              :picker-options="pickerOptions" type="month" placeholder="请选择自然月"
                              size="small" >
              </el-date-picker>
            </div>
          </div>
        </template>
        <template slot="actions">
          <button class="common-bg-button" @click="getListData(pagination, true)">查 询</button>
        </template>
      </ZD-list-querys>
      <!-- 表格 -->
      <div class="list-table">
        <button class="common-bg-button" @click="handleExport">导 出</button>
        <el-table :data="tableData" style="width: 100%" border stripe @selection-change="(sels) => {selections = sels;}">
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column type="index" width="40" align="center" />
          <el-table-column prop="isHostOperateName" label="运营类别" width="200" align="center" />
          <el-table-column prop="dealerName" label="运营商名称" width="200" align="center" />
          <el-table-column prop="stationName" label="电站名称" width="200" align="center">
            <template slot-scope="scope">
              <el-button @click="handleEditStationName(scope.row)" type="text" size="small">{{ scope.row.stationName }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="pileCode" label="桩编号" width="200" align="center">
            <template slot-scope="scope">
              <el-button @click="handleEditPileCode(scope.row)" type="text" size="small">{{ scope.row.pileCode }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="pileTypeName" label="充电桩型号" width="200" align="center" />
          <el-table-column prop="beginTime" label="开始时间" width="200" align="center" />
          <el-table-column prop="endTime" label="结束时间" width="200" align="center" />
          <el-table-column prop="orderNum" label="订单量" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderNum">{{ scope.row.orderNum }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="unPaidOrderNum" label="未支付数量" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.unPaidOrderNum">{{ scope.row.unPaidOrderNum }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="dailyOrderNum" label="日均订单量" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.dailyOrderNum">{{ scope.row.dailyOrderNum }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalChargeCount" label="总电量(度)" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.totalChargeCount">{{ scope.row.totalChargeCount }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="avgChargeCount" label="平均订单电量" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.avgChargeCount">{{ scope.row.avgChargeCount }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalChargeMin" label="总时长" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.totalChargeMin">{{ scope.row.totalChargeMin }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="avgChargeMin" label="平均订单时长" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.avgChargeMin">{{ scope.row.avgChargeMin }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalElecFee" label="总金额" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.totalElecFee">{{ scope.row.totalElecFee }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="avgElecFee" label="平均客单价" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.avgElecFee">{{ scope.row.avgElecFee }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="userNum" label="用户数" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.userNum">{{ scope.row.userNum }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="elecFee" label="应收电费(元)" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.elecFee">{{ scope.row.elecFee }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="actElecFee" label="实收电费(元)" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.actElecFee">{{ scope.row.actElecFee }}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="balanceElecFee" label="账户余额支付(元)" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.balanceElecFee == 0">{{scope.row.balanceElecFee}}</span>
              <span v-else-if="scope.row.balanceElecFee != 0">{{scope.row.balanceElecFee}}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="otherElecFee" label="度电支付(k-Wh)" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.otherElecFee == 0">{{scope.row.otherElecFee}}</span>
              <span v-else-if="scope.row.otherElecFee != 0">{{scope.row.otherElecFee}}</span>
              <span v-else style="color: blue;">数据计算中</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="数据统计日期" width="200" align="center"></el-table-column>
          <!--
          <el-table-column fixed="right" label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">更新数据</el-button>
            </template>
          </el-table-column>
          -->
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
    import pageConfig from "./page-config";
    import util from "@/common/util.js";
    import utils from "@/utils/utils.js";
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                pagination: pageConfig.pagination,
                dealerArr: [], // 运营类别
                siteArr: [], // 电站名称
                tableData: [], // 表格数据
                selections: [], // 表格选项
                queryInfo: {
                    chargeMonth: '', // 选择月份
                    isHostOperate: '', // 运营类型
                    dealNo: '', // 运营商
                    stationNo: '', // 电站
                    pageNum: '',
                    pageSize: ''
                }, //标签页与 搜索框
                pickerMinDate: "",
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        this.pickerMinDate = minDate.getTime();
                        //如果选中结束时间,则小于所选当前时间
                        if (maxDate) {
                            this.pickerMinDate = "";
                        }
                    },
                    disabledDate: (time) => {
                        if (this.pickerMinDate !== "") {
                            let one = 30 * 24 * 3600 * 1000;
                            let minTime = this.pickerMinDate - one;
                            let maxTime = this.pickerMinDate + one;
                            if (maxTime > new Date()) {
                                maxTime = new Date();
                            }
                            return time.getTime() < minTime || time.getTime() > maxTime;
                        }
                        return time.getTime() > Date.now();
                    },
                },
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            // 初始化
            init() {
                this.getListData(this.pagination, true);
                this.getDealer();
            },
            // 运营商数据
            getDealer() {
                let _ = this;
                _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
                    _.dealerArr = res.data.data;
                });
            },
            // 根据运营商筛选 电站
            handleSelectOperate(){
                let _ = this;
                if(_.queryInfo.dealNo){
                  _.getSite();
                }
            },
            // 电站数据
            getSite(val) {
                let _ = this;
                let obj = {
                    isHostOperate: _.queryInfo.isHostOperate,
                    dealerNo: val || _.queryInfo.dealName,
                };
                _.$H.post(_, _.$A.pileStation.listStationByDeal, obj).then((res) => {
                    _.siteArr = res.data.data || [];
                });
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.$H.post(_, _.$A.finance.getpileReport, _.queryInfo).then((res) => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                });
            },

            // 导出
            handleExport() {
                let _ = this;
                if (this.selections.length <= 0) {
                    utils.error("请选择需要操作的记录");
                    return;
                } else {
                    _.$U.showLoading(_);
                    _.$H.post(_, _.$A.finance.exportPileReport, _.selections).then((res) => {
                        _.$U.hideLoading(_);
                        _.$U.saveExcelFile(res.data.data)
                    });
                }
            },
            // 编辑、查看 电站
            handleEditStationName(row){
                let _ = this;
                _.$store.commit('setEditId', row.stationId);
                window.open(_.$router.resolve({name: "pileStationDetail", query: {editId: row.stationId}}).href, "_blank");
            },
            // 编辑、查看 桩编号
            handleEditPileCode(row){
                let _ = this;
                _.$store.commit("setEditId", row.pileCode);
                window.open(_.$router.resolve({ name: "pileDetail" }).href, "_blank");
            },
            // 更新数据
            handleClick(row) {
                let _ = this;
                // _.$U.showLoading(_);
                // _.$H.post(_, _.$A.pileStation.del, { staticId: row.staticId }).then((res) => {
                //     _.getListData(this.pagination, true);
                //     _.$U.showLoading(_);
                // });
            },
        },
    };
</script>
